<div id="topicsNavigation">
    <ul class="topics">
        <li class="topic title">
            <a
                [routerLink]="activeSubject.getBrowseURL()"
                queryParamsHandling="merge"
                [ngClass]="{ active: activeNode === activeSubject }"
                [ngStyle]="{
                    'background-color': activeNode === activeSubject ? colorCode : 'transparent'
                }"
            >
                All {{ activeSubject.title }}
            </a>
        </li>
        <li class="topic" *ngFor="let topic of activeSubject.children">
            <a
                *ngIf="topic.resultsCount"
                [routerLink]="topic.getBrowseURL()"
                queryParamsHandling="merge"
                [ngClass]="{ active: activeNode === topic }"
                [ngStyle]="{
                    'background-color': activeNode === topic ? colorCode : 'transparent'
                }"
                id="selenium-topic-{{ topic.id }}"
            >
                {{ topic.title }}
            </a>
            <ul class="subtopics arrow-right" [ngbCollapse]="topic !== activeTopic">
                <li class="subtopic" *ngFor="let subtopic of topic.children">
                    <a
                        *ngIf="subtopic.resultsCount"
                        [routerLink]="subtopic.getBrowseURL()"
                        queryParamsHandling="merge"
                        [ngClass]="{ active: activeNode === subtopic }"
                        [ngStyle]="{
                            'background-color': activeNode === subtopic ? colorCode : 'transparent'
                        }"
                        id="selenium-subtopic-{{ subtopic.id }}"
                    >
                        {{ subtopic.title }}
                    </a>
                </li>
            </ul>
        </li>
    </ul>
</div>
